import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as values from '../../../values'

export const INPUT = graphql.transformers.IN.lazy(() =>
  graphql.transformers.IN.object<
    ents.core.dms.data.Value.Type,
    graphql.schema.DmsValueTypeInput
  >({
    enum: input =>
      ents.core.dms.data.Value.Type.Enum.isEnum(input)
        ? DMS_ENUM_VALUE_TYPE_INPUT.getGqlFrom(input)
        : undefined,
    files: input =>
      ents.core.dms.data.Value.Type.Files.isFiles(input)
        ? DMS_FILES_VALUE_TYPE_INPUT.getGqlFrom(input)
        : undefined,
    inlineEnum: input =>
      ents.core.dms.data.Value.Type.Enum.Inline.isInline(input)
        ? DMS_INLINE_ENUM_VALUE_TYPE_INPUT.getGqlFrom(input.inlineEnum)
        : undefined,
    intrinsic: input =>
      ents.core.common.value.types.Intrinsic.isIntrinsic(input)
        ? values.enums.intrinsicValueType.TRANSFORMER.getGqlFrom(input)
        : undefined,
    multiReference: input =>
      ents.core.dms.data.Value.Type.Reference.Multi.isMulti(input)
        ? DMS_MULTI_REFERENCE_VALUE_TYPE_INPUT.getGqlFrom(input)
        : undefined,
    reference: input =>
      ents.core.dms.data.Value.Type.Reference.isReference(input)
        ? DMS_REFERENCE_VALUE_TYPE_INPUT.getGqlFrom(input)
        : undefined,
    structure: input =>
      ents.core.dms.data.Value.Type.Structure.isStructure(input)
        ? DMS_STRUCTURE_VALUE_TYPE_INPUT.getGqlFrom(input)
        : undefined,
  }),
)

export const DMS_ENUM_VALUE_TYPE_INPUT = graphql.transformers.IN.object<
  ents.core.dms.data.Value.Type.Enum,
  graphql.schema.DmsEnumValueTypeInput
>({
  enumId: transformers.PASS_THROUGH,
  isMultiselect: transformers.PASS_THROUGH,
})

export const DMS_REFERENCE_VALUE_TYPE_INPUT = graphql.transformers.IN.object<
  ents.core.dms.data.Value.Type.Reference,
  graphql.schema.DmsReferenceValueTypeInput
>({
  dimensionId: transformers.PASS_THROUGH,
})

export const DMS_FILES_VALUE_TYPE_INPUT = graphql.transformers.IN.object<
  ents.core.dms.data.Value.Type.Files,
  graphql.schema.DmsFilesValueTypeInput
>({
  isFile: transformers.PASS_THROUGH,
})

export const DMS_STRUCTURE_VALUE_TYPE_INPUT = graphql.transformers.IN.object<
  ents.core.dms.data.Value.Type.Structure,
  graphql.schema.DmsStructureValueTypeInput
>({
  structureId: transformers.PASS_THROUGH,
})

export const DMS_MULTI_REFERENCE_VALUE_TYPE_INPUT =
  graphql.transformers.IN.object<
    ents.core.dms.data.Value.Type.Reference.Multi,
    graphql.schema.DmsMultiReferenceValueTypeInput
  >({
    dimensionId: transformers.PASS_THROUGH,
  })

export const ENUM_VALUE_TYPE_ENTRY_INPUT = graphql.transformers.IN.object<
  ents.core.common.value.types.Enum.Entry,
  graphql.schema.EnumValueTypeEntryInput
>({
  description: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
  name: transformers.PASS_THROUGH,
})

export const DMS_INLINE_ENUM_VALUE_TYPE_INPUT = graphql.transformers.IN.object<
  ents.core.common.value.types.Enum,
  graphql.schema.DmsInlineEnumValueTypeInput
>({
  entries: graphql.transformers.IN.list(ENUM_VALUE_TYPE_ENTRY_INPUT, {
    onNullish: 'remove',
  }),
  isMultiselect: transformers.PASS_THROUGH,
})
